
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { SettingsOmrVO } from '@/components/vo/Settings.vo'
import axios from 'axios'
import CommonUtils from '@/common-utils'
import Constants from '@/constants'

@Component
export default class Settings extends Vue {
  settingsOmrVO: SettingsOmrVO = {} as SettingsOmrVO;
  msgDialog = false;
  currentHelpMsg = {};

  gradeHelpMsg = {
    title: '채점모드 도움말',
    msg: '각 문항을 선택할 때마다 자동으로 채점을 해주는 기능이예요. 설정된 문항수에 따라 채점이 자동으로 진행돼요.',
  };

  correctAnswerPstgMsg = {
    title: '정답률 도움말',
    msg: '모든 수험생들이 제출한 데이터의 정답률을 계산하여 각 문항에 표시를 해줘요. 낮게 설정할수록 고난이도의 문제들만 노출돼요.',
  }

  hideGradeSuccessMsg = {
    title: '문항 가리기 도움말',
    msg: '채점이 완료된 문제는 답안지에서 가려요. 채점이 완료된 문항이 계속 보일 필요는 없겠죠?',
  }

  isGroupQuestionMsg = {
    title: '오답노트 문항노출 도움말',
    msg: '내가 푼 문제의 정답률이 오답노트에 노출될지 여부를 결정해요. 보고싶은 구간만 선택하면 보기 더 편해요.'
  }

  hideModeMsg = {
    title: '가리기 모드 도움말',
    msg: '비노출 문항을 완전히 가리거나 또는 흐리게 노출되도록 설정해요.'
  }

  openHelpMessages(msg): void {
    this.msgDialog = !this.msgDialog;
    this.currentHelpMsg = msg;
  }

  closeDialog(): void {
    this.$store.dispatch(`settings/closeModal`, {name: 'settings'});
  }

  escKeyDownEventHandler(e) {
    if(e.keyCode != 27) {
      return;
    }
    this.closeDialog();
  }

  @Watch('settingsOmrVO', {deep: true})
  changeSettings(ev: SettingsOmrVO): void {
    CommonUtils.putLocalStorageObject(Constants.SETTINGS_OMR, this.settingsOmrVO)
  }

  @Watch('$store.state.settings.opened')
  init(e): void {
    if(!e) {
      return;
    }
    this.settingsOmrVO = CommonUtils.getLocalStorageObject(Constants.SETTINGS_OMR);
  }


}
